module.exports = __webpack_public_path__ + "f8380d46b647c1b10f081c8e27a39079.png";